AGA.Page = (function () {

    var hideEmptyGroups = function() {
        
        var groupsToCheck = [];

        $(".tab-pane.hidden").each(function() {
            var tabId = $(this).attr("id");
            var widgetId = tabId.substring(3);
            var li = $("li.aga-li[data-widget-id='" + widgetId + "']");
            if (!$(li).is(".hidden")) {
                $(li).addClass("hidden");

                // Se o parent é um agrupamento adiciona para verificar depois
                if ($(li).parent().is(".aga-tab-dropdown")) {
                    groupsToCheck.push($(li).parent().parent().get(0));
                }
            }
        });

        // Verificar se algum grupo ficou vazio
        groupsToCheck = $.unique(groupsToCheck);
        $.each(groupsToCheck, function() {
            if ($(this).find("li:not(.hidden)").length === 0) {
                $(this).addClass("hidden");
            }
        });
    };

    var internalInit = function () {
        setTimeout(hideEmptyGroups, 1);
    };

    return {
        init: function () {
            internalInit();
        }
    };

})();

